import React, {Component} from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import {disableBodyScroll, enableBodyScroll} from 'body-scroll-lock'

import styles from './Modal.scss'

export default class Modal extends Component {
    constructor(props) {
        super(props)

        this.modal = React.createRef()
        this.el = document.createElement('div')

        this.bodyClasses = document.body.className
    }

    componentDidMount() {
        disableBodyScroll(this.modal.current)

        document.body.className += ' modal-open-fix';

        document.addEventListener('keydown', this.onKeyDown)
        document.getElementById('react-app-modal').appendChild(this.el)
    }

    componentWillUnmount() {
        enableBodyScroll(this.modal.current)

        document.removeEventListener('keydown', this.onKeyDown)
        document.getElementById('react-app-modal').removeChild(this.el)

        setTimeout(() => {
            document.body.className = this.bodyClasses;
        })
    }

    onKeyDown = e => {
        if (e.keyCode === 27) {
            // Esc.
            this.onOutsideAction()
        }
    }

    onOutsideAction = () => {
        if (this.props.disabled) {
            return
        }

        this.props.onOutsideAction && this.props.onOutsideAction()
    }

    onOutsideClick = ({target}) => {
        if (this.backdrop === target) {
            this.onOutsideAction()
        }
    }

    modal = null

    render() {
        const {children, width, backdropOnly, disablePortal, style} = this.props

        const element = (
            <div className={styles.root}>
                <div className={styles.backdrop} onClick={this.onOutsideClick}
                     ref={backdrop => this.backdrop = backdrop}>
                    <div className={!backdropOnly ? styles.modal : undefined} style={{width, ...style}}
                         ref={this.modal}>
                        {children}
                    </div>
                </div>
            </div>
        )

        if (disablePortal) {
            return element
        }

        return ReactDOM.createPortal(element, this.el)
    }
}

Modal.propTypes = {
    width: PropTypes.any,
    disabled: PropTypes.bool,
    onOutsideAction: PropTypes.func,
    backdropOnly: PropTypes.bool,
    disablePortal: PropTypes.bool,
    style: PropTypes.object
}
